// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorSellers = (client) => ({
    /**
     * `POST /vendor/sellers`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateSeller
     * @source packages/modules/b2c-core/src/api/vendor/sellers/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/sellers", { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/sellers/me/reviews`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetSellerMyReviews
     * @source packages/modules/reviews/src/api/vendor/sellers/me/reviews/route.ts
     */
    listMeReviews: (query, headers) => client.fetch("/vendor/sellers/me/reviews", { method: "GET", query, headers }),
    /**
     * `GET /vendor/sellers/me`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetSellerMe
     * @source packages/modules/b2c-core/src/api/vendor/sellers/me/route.ts
     */
    retrieveMe: (query, headers) => client.fetch("/vendor/sellers/me", { method: "GET", query, headers }),
    /**
     * `GET /vendor/sellers/me/onboarding`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetOnboardingStatus
     * @source packages/modules/b2c-core/src/api/vendor/sellers/me/onboarding/route.ts
     */
    retrieveMeOnboarding: (query, headers) => client.fetch("/vendor/sellers/me/onboarding", { method: "GET", query, headers }),
    /**
     * `GET /vendor/sellers/me/reviews/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetSellerReviewById
     * @source packages/modules/reviews/src/api/vendor/sellers/me/reviews/[id]/route.ts
     */
    retrieveMeReview: (id, query, headers) => client.fetch(buildPath("/vendor/sellers/me/reviews/:id", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/sellers/me`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateSellerMe
     * @source packages/modules/b2c-core/src/api/vendor/sellers/me/route.ts
     */
    updateMe: (body, query, headers) => client.fetch("/vendor/sellers/me", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/sellers/me/onboarding`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorRecalculateOnboarding
     * @source packages/modules/b2c-core/src/api/vendor/sellers/me/onboarding/route.ts
     */
    updateMeOnboarding: (body, query, headers) => client.fetch("/vendor/sellers/me/onboarding", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/sellers/me/reviews/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateReviewById
     * @source packages/modules/reviews/src/api/vendor/sellers/me/reviews/[id]/route.ts
     */
    updateMeReview: (id, body, query, headers) => client.fetch(buildPath("/vendor/sellers/me/reviews/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=sellers.js.map